(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["atelier-ui-styles"] && !Shopify.designMode) return;
  try {
    if (!window.douvaneVariantUI) {
  window.douvaneVariantUI = true;
  document.addEventListener('change', (event) => {
    const selector = event.target.closest('[data-variant-select]');
    if (!selector) return;
    const option = selector.selectedOptions[0];
    const box = selector.closest('[data-buybox]');
    const app = selector.closest('.espresso-app');
    if (!option || !box || !app) return;
    const available = option.dataset.available === 'true';
    const price = box.querySelector('[data-product-price]');
    const compare = box.querySelector('[data-product-compare]');
    const saving = box.querySelector('[data-product-saving]');
    const stock = box.querySelector('[data-product-stock]');
    if (price) price.textContent = option.dataset.price;
    if (compare) { compare.textContent = option.dataset.compare; compare.hidden = !option.dataset.compare; }
    if (saving) { saving.textContent = option.dataset.saving; saving.hidden = !option.dataset.saving; }
    if (stock) {
      const label = stock.querySelector('[data-stock-label]');
      const text = option.dataset.stockLabel || '';
      stock.hidden = !text;
      if (label) label.textContent = text;
    }
    app.querySelectorAll('[data-sticky-price]').forEach((node) => { node.textContent = option.dataset.price; });
    [...box.querySelectorAll('[data-product-submit]'), ...app.querySelectorAll('[data-sticky-submit]')].forEach((button) => {
      button.disabled = !available;
      const label = button.querySelector('[data-button-label]');
      if (label) label.textContent = available ? button.dataset.addLabel : button.dataset.soldLabel;
    });
    const status = box.querySelector('[data-product-status]');
    if (status) status.textContent = '';
    if (document.body.classList.contains('template-product')) {
      const url = new URL(window.location.href);
      url.searchParams.set('variant', option.value);
      window.history.replaceState({}, '', url);
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["espresso-angle-gallery"] && !Shopify.designMode) return;
  try {
    if (!window.douvaneAngleGalleryReady) {
  window.douvaneAngleGalleryReady = true;
  const showAnglePhoto = (gallery, index) => {
    const slides = [...gallery.querySelectorAll('[data-angle-slide]')];
    const buttons = [...gallery.querySelectorAll('[data-angle-index]')];
    if (!slides.length) return;
    const active = ((index % slides.length) + slides.length) % slides.length;
    slides.forEach((slide, i) => { slide.hidden = i !== active; });
    buttons.forEach((button, i) => { button.setAttribute('aria-pressed', String(i === active)); });
    gallery.dataset.angleActive = String(active);
    const status = gallery.querySelector('[data-angle-status]');
    if (status) status.textContent = buttons[active].textContent.trim() + ' · ' + (active + 1) + ' / ' + slides.length;
  };
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-angle-index], [data-angle-step]');
    if (!button) return;
    const gallery = button.closest('[data-angle-gallery]');
    if (!gallery) return;
    const index = button.hasAttribute('data-angle-index') ? Number(button.dataset.angleIndex) : Number(gallery.dataset.angleActive || 0) + Number(button.dataset.angleStep);
    showAnglePhoto(gallery, index);
  });
  document.addEventListener('keydown', event => {
    const button = event.target.closest('[data-angle-index]');
    if (!button || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
    const gallery = button.closest('[data-angle-gallery]');
    const buttons = [...gallery.querySelectorAll('[data-angle-index]')];
    const index = Number(button.dataset.angleIndex);
    const next = event.key === 'Home' ? 0 : event.key === 'End' ? buttons.length - 1 : (index + (event.key === 'ArrowRight' ? 1 : -1) + buttons.length) % buttons.length;
    event.preventDefault();
    showAnglePhoto(gallery, next);
    buttons[next].focus();
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["espresso-gallery"] && !Shopify.designMode) return;
  try {
    if (!window.douvaneGalleryReady) {
 window.douvaneGalleryReady = true;
 const setSlide = (gallery,index) => {
  const slides = [...gallery.querySelectorAll('[data-gallery-slide]')];
  const buttons = [...gallery.querySelectorAll('[data-gallery-index]')];
  if (!slides.length) return;
  const active = ((index % slides.length) + slides.length) % slides.length;
  slides.forEach((slide,i) => { slide.hidden = i !== active; });
  buttons.forEach((button,i) => button.setAttribute('aria-pressed',String(i === active)));
  gallery.dataset.activeIndex = String(active);
  const status = gallery.querySelector('[data-gallery-status]');
  if (status) status.textContent = buttons[active].textContent.trim() + ' · ' + (active + 1) + ' / ' + slides.length;
 };
 document.addEventListener('click',event => {
  const button=event.target.closest('[data-gallery-index],[data-gallery-step]');
  if(!button) return;
  const gallery=button.closest('[data-coffee-gallery]');
  if(!gallery) return;
  const index=button.hasAttribute('data-gallery-index')?Number(button.dataset.galleryIndex):Number(gallery.dataset.activeIndex||0)+Number(button.dataset.galleryStep);
  setSlide(gallery,index);
 });
 document.addEventListener('keydown',event => {
  const button=event.target.closest('[data-gallery-index]');
  if(!button||!['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
  event.preventDefault();
  const gallery=button.closest('[data-coffee-gallery]');
  const buttons=[...gallery.querySelectorAll('[data-gallery-index]')];
  const next=event.key==='Home'?0:event.key==='End'?buttons.length-1:(Number(button.dataset.galleryIndex)+(event.key==='ArrowRight'?1:-1)+buttons.length)%buttons.length;
  setSlide(gallery,next);buttons[next].focus();
 });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["espresso-localization"] && !Shopify.designMode) return;
  try {
    document.addEventListener('submit', event => {
  const form = event.target.closest('[data-localization-form]');
  if (!form) return;
  const destination = form.querySelector('input[name="return_to"]');
  if (destination) destination.value = window.location.pathname + window.location.search + window.location.hash;
});
document.addEventListener('click', event => {
  document.querySelectorAll('[data-localization][open]').forEach(selector => {
    if (!selector.contains(event.target)) selector.removeAttribute('open');
  });
});
document.addEventListener('keydown', event => {
  if (event.key !== 'Escape') return;
  const selector = event.target.closest('[data-localization][open]');
  if (selector) {
    selector.removeAttribute('open');
    selector.querySelector('summary').focus();
  }
});
  } catch(e) { console.error(e); }
})();

})();
